<template>
  <div class="relative" ref="dropdownContainer">
    <div class="h-6 px-2.5 py-3 bg-surface-2 rounded-full flex justify-center items-center gap-1.5 cursor-pointer select-none hover:bg-surface-3 transition-colors"
         :class="{ 'opacity-50 cursor-not-allowed': disabled }"
         @click.stop="toggleDropdown">
      <div class="text-text-default text-sm font-normal leading-4 tracking-tight whitespace-nowrap">{{ displayLabel }}</div>
      <i class="ri-arrow-down-s-line text-text-subtle text-xs transition-transform duration-200" :class="{ 'rotate-180': is_open }"></i>
    </div>
    <!-- Dropdown panel -->
    <div v-if="is_open" class="absolute z-50 mt-1 min-w-full bg-surface-1 rounded-lg border border-border-default shadow-lg py-1" @click.stop>
      <div v-for="option in options"
           :key="getOptionValue(option)"
           class="px-3 py-2 cursor-pointer hover:bg-surface-2 transition-colors text-sm"
           :class="isSelected(option) ? 'bg-brand-subtle text-text-link font-medium' : 'text-text-default'"
           @click.stop="selectOption(option)">
        {{ getOptionLabel(option) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: [String, Number, null],
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      is_open: false
    }
  },
  computed: {
    displayLabel() {
      const selectedOption = this.options.find(opt => this.getOptionValue(opt) === this.modelValue);
      return selectedOption ? this.getOptionLabel(selectedOption) : this.$t('common.dropdown.select');
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    getOptionValue(option) {
      return typeof option === 'object' ? option.value : option;
    },
    getOptionLabel(option) {
      return typeof option === 'object' ? option.label : option;
    },
    isSelected(option) {
      return this.getOptionValue(option) === this.modelValue;
    },
    toggleDropdown() {
      if (this.disabled) return;
      this.is_open = !this.is_open;
    },
    selectOption(option) {
      this.$emit('update:modelValue', this.getOptionValue(option));
      this.is_open = false;
    },
    handleClickOutside(e) {
      if (this.$refs.dropdownContainer && !this.$refs.dropdownContainer.contains(e.target)) {
        this.is_open = false;
      }
    }
  }
}
</script>
